import type { IStringTool } from "../core/IStringTool.ts"

interface DOMAttributeInput {
  element: HTMLElement
  key: string // for example: "offset-tom"
  fallback?: string | null
}

export default class DOMAttributeTool implements IStringTool<DOMAttributeInput, string | null> {
  /**
   * Retrieves the value of either `string-${key}` or `data-string-${key}` attribute.
   *
   * @example key = "offset-tom" → tries:
   *   - element.getAttribute("string-offset-tom")
   *   - element.getAttribute("data-string-offset-tom")
   */
  process({ element, key, fallback = null }: DOMAttributeInput): string | null {
    return (
      element.getAttribute(`string-${key}`) ??
      element.getAttribute(`data-string-${key}`) ??
      fallback
    )
  }
}
